export const CONFIG = {
	SERVER_URL: "http://3.26.12.42",
	ADMIN_BASE_URL: "http://3.26.12.42",
	ERROR_LOG_URL: "http://3.26.12.42/error.log"
};
